import type { Question } from '@mentimeter/legacy-series-types/question';
import type { EditorSlide } from '../../../compatibility-overrides/editor-types';

export const editorSlidePropertyKeys: Array<keyof EditorSlide> = [
  'hasComments',
];

export const editorQuestionPropertyKeys: Array<keyof Question> = [
  'has_comments',
];
